<template lang="pug">
#app(:class="appClass" :ua="userAgent" v-if="!iframed")
  iframe(src="/media/1-second-of-silence.mp3" allow="autoplay" id="audio" style="display: none")
  router-view(name='header')
  router-view(name='social')
  //vue-advanced-chat(:current-user-id="currentUserId" :rooms="JSON.stringify(rooms)" :rooms-loaded="true" :messages="JSON.stringify(messages)" :messages-loaded="messagesLoaded")
  div#page-overlay(:class="spinner ? 'spinner' : ''")
    div#geno-spinner(style="text-align: center")
      .spin-container(style="width: 136px; height: 100vh; display: inline-block;")
        geno-logo.spinner(:class="spinner ? 'rotateLoading' : ''" style="width: 136px; height: 136px;" )
        el-progress.progress(v-if="progress > 0" type="circle" :percentage="progress" :width="256" :height="256" :stroke-width="0" firstcolor="#1bc18b" color="#2e668c" style="opacity:0.5;" )
  #exportImage(style="left:0;opacity: 0; top:0; pointer-events: none;position: absolute;width: 100%;")
    img#editImage(vif="editingImage" ref="imgRef" :src="editedImageUrl" style="width: 100%;" crossorigin="anonymous")
    img#editImage2(vif="editingImage" ref="imgRef2" :src="editedImageUrl2" style="position: absolute;width: 100%;left:0;display:none;")
  div#page(:class="topClass")
    router-view(:key="routeKey")
      //transition( name="fade" )
        component( :is="Component" )
  login-modal
  verify-mfa-modal
  annotate-modal(v-if="frontpageLoaded || user && user.username")
  history-modal(v-if="g25Loaded || pcaLoaded || admixLoaded || discussLoaded ")
  custom-dialog
  save-dialog
  v-dialog(@before-open="beforeOpen" @before-close="beforeClose")
  img#logout(border="0" width="1" height="1" style="display:none;")
</template>
<script>
import {onLCP, onFID, onCLS} from 'web-vitals/attribution';
//onCLS(console.log);
//onFID(console.log);
//onLCP(console.log);
//import { register } from 'vue-advanced-chat'
//register()
const LoginModal = () => import('./components/modals/LoginModal.vue')
const VerifyMfaModal = () => import('./components/modals/VerifyMfaModal.vue')
const AnnotateModal  = () => import('./components/modals/annotate.vue')
const HistoryModal  = () => import('./components/modals/historyModal.vue');
const customDialog = () =>  import('./components/modals/customDialog.vue');
const saveDialog = () =>  import('./components/modals/saveDialog.vue');
import axios from 'axios'
const breadcrumbs = require('./breadcrumbs.json')
import {
    store
} from "./Store"
import { AmplifyEventBus } from './plugins/aws-amplify-vue';
import {
    mapState
} from 'vuex'
  let resizeTimeout;
  function resizeThrottler(actualResizeHandler) {
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        actualResizeHandler();
      }, 66);
    }
  }
export default {
    name: 'app',
    //bodyClass: ['iPod Simulator', 'iPhone', 'iPod', 'iPad'].includes(navigator.platform) || window.navigator && window.navigator.userAgentData && window.navigator.userAgentData.mobile ? 'isMobile' : 'isDesktop',
    bodyClass: ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document) || window.navigator && window.navigator.userAgentData && window.navigator.userAgentData.mobile ? 'isMobile' : 'isDesktop',
    metaInfo: {
      script: [{
          type: "application/ld+json",
          innerHTML: JSON.stringify(breadcrumbs)
      }],
    },
    components: {
        LoginModal,
        VerifyMfaModal,
        AnnotateModal,
        HistoryModal,
        customDialog,
        saveDialog
    },
    data() {
        return {
            transitionName: "",
            iframed: false,
            scrolled: false,
            currentUserId: '1234',
            rooms: [{
                roomId: '1',
                roomName: 'Room 1',
                avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj',
                users: [{
                        _id: '1234',
                        username: 'John Doe'
                    },
                    {
                        _id: '4321',
                        username: 'John Snow'
                    }
                ]
            }],
            messages: [],
            messagesLoaded: false
        };
    },
    watch: {
        /*
        $route(to, from) {
          this.transitionName = to.meta.page > from.meta.page ? "next" : "prev";
        }
        */
    },
    methods: {
        fetchMessages({
            options = {}
        }) {
            setTimeout(() => {
                if (options.reset) {
                    this.messages = this.addMessages(true)
                } else {
                    this.messages = [...this.addMessages(), ...this.messages]
                    this.messagesLoaded = true
                }
                // this.addNewMessage()
            })
        },

        addMessages(reset) {
            const messages = []

            for (let i = 0; i < 30; i++) {
                messages.push({
                    _id: reset ? i : this.messages.length + i,
                    content: `${reset ? '' : 'paginated'} message ${i + 1}`,
                    senderId: '4321',
                    username: 'John Doe',
                    date: '13 November',
                    timestamp: '10:20'
                })
            }

            return messages
        },

        sendMessage(message) {
            this.messages = [
                ...this.messages,
                {
                    _id: this.messages.length,
                    content: message.content,
                    senderId: this.currentUserId,
                    timestamp: new Date().toString().substring(16, 21),
                    date: new Date().toDateString()
                }
            ]
        },

        addNewMessage() {
            setTimeout(() => {
                this.messages = [
                    ...this.messages,
                    {
                        _id: this.messages.length,
                        content: 'NEW MESSAGE',
                        senderId: '1234',
                        timestamp: new Date().toString().substring(16, 21),
                        date: new Date().toDateString()
                    }
                ]
            }, 2000)
        },
        beforeOpen(event) {
            console.log('open ', event)
        },
        beforeClose(event) {
            console.log('close ', event)
        },
        scrollListener() {
            resizeThrottler(this.handleScroll)
        },
        log(evt) {
            console.log('loaded', evt)
        },
        closeIntercom() {
            AmplifyEventBus.$emit('appEvents', {
                exec: 'closeIntercom',
                component: 'nav'
            })
        },
        handleScroll() {
            let container = document.getElementById('app')
            let scrollValue = container.scrollTop || 0
            this.scrolled = (scrollValue > 75 ? 'scrolled' : 'unscrolled')
        },
        debug() {}
    },
    computed: {
        ...mapState({
            frontpageLoaded: 'frontpageLoaded',
            g25Loaded: 'g25Loaded',
            imageSource: 'imageSource',
            pcaLoaded: 'pcaLoaded',
            discussLoaded: 'discussLoaded',
            admixLoaded: 'admixLoaded',
            genolabs: 'genolabs',
            navLoaded: 'navLoaded',
            user: 'user'
        }),
        routeKey: function() {
            return store.getters.get('routeKey')
        },
        spinner: function() {
            return store.getters.get('spinner')
        },
        showlab: {
            get() {
                return store.getters.get('showlab')
            },
            set(value) {
                store.commit('change', {
                    showlab: value
                })
            }
        },
        userAgent: function() {
            return navigator.userAgent
        },
        isMobile: function() {
            let ios = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            let mobile = navigator.userAgentData && navigator.userAgentData.mobile ? true : false
            return (ios || mobile) ? true : false
        },
        appClass: function() {
            let klass = []
            if (this.scrolled) klass.push(this.scrolled)
            if (this.userAgent.includes('Prerender')) klass.push('prerender')
            if (this.isMobile) klass.push('isMobile')
            klass = klass.join(' ')
            return klass
        },
        progress: function() {
            return store.getters.get('progress')
        },
        topClass: function() {
            return store.getters.get('topClass') === true ? 'fullscreen' : ''
        },
        editingImage: function() {
            return store.getters.get('editingImage')
        },
        editedImageUrl: function() {
            return store.getters.get('editedImageUrl')
        },
        editedImageUrl2: function() {
            return store.getters.get('editedImageUrl2')
        }
    },
    mounted() {
        window.name = 'GenoplotPWA';
        setTimeout(() => {
            var container = document.getElementById('app')
            if (container) {
                container.addEventListener('scroll', this.scrollListener)
                container.addEventListener('click', this.closeIntercom)
            }
        }, 0)
    },
    beforeDestroy() {
        var container = document.getElementById('app')
        container.removeEventListener('scroll', this.scrollListener)
        container.removeEventListener('click', this.closeIntercom)
    },
    async beforeCreate() {
    },
    created() {
        if (window.parent && window.location != window.parent.location) {
            window.parent.postMessage({
                event: 'iframedError',
                source: 'genoplot'
            }, '*')
            this.iframed = true;
            this.$store.commit('change', {
                topClass: false
            })
        }
    }
}
</script>
<style src="./style/vue-multiselect.min.css"></style>
<style lang="scss">
.tooltip .tooltip-inner {
cursor: default;
}
body.dark {
/*color-scheme: dark;*/
background: #181818;
}
body #app .btn {
display: inline-flex !important;
align-items: center !important;
justify-content: center !important;
}
body #page-overlay.spinner {
    opacity: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background-color: #0000000f;
    z-index: 9999999;
    transition: all 0.3s;
}
body #page-overlay {
    opacity: 0;
    position: fixed;
        width: 100%;
            height: 100%;
            pointer-events: none;
                background-color: #00000000;
                    z-index: 1;
                    transition: all 0.3s;
                    }
#geno-spinner {
text-align: center;
}
#geno-spinner .spin-container {
        height: 100vh;
                    display: inline-block;
                    }
#geno-spinner svg.spinner {
    position: relative;
    top: 35%;
    background: #f33e3e;
    background: #4e88b5;
    background: #2a465c87;
    border-radius: 99px;
}

#geno-spinner .progress {
position: relative;
top: 35%;
width: 136px;
height: 136px;
margin-top: -40px;
background: rgba(0,0,0,0);
color: white;
}

body.dark #geno-spinner svg.spinner {
background: hsl(206, 16%, 40%);
background: hsla(206, 25%, 65%, 0.5);
}

body, #app, #page {
transition: background 0.3s, background-color 0.3s
}


#app .btn-primary {
background-color: #E46F49 !important;
background-color: #E65929 !important;
}
#cb-container {
overflow: hidden !important;
}



body.light.presentation-page {
background-color: #cda69d !important;
}

body {
overflow: hidden;
width: calc(100% + 20px);
}

#app {
  display: grid;
  grid-template-rows: min-content;
  min-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}



/* Transitions */
main > * {
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1;
}

.next-leave-to {
  animation: leaveToLeft 200ms;
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 200ms;
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 200ms;
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
    filter: opacity(0.1);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
    filter: opacity(0.1);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.overlay-left,  .overlay-right,  .overlay-top,  .overlay-bottom   { 
background: #cda69d !important;
}
#app .btn-primary, #app .btn-round, #app .btn-icon {
box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
body .v--modal-overlay {
z-index: 999999;
}
body #app #navparent .v--modal-overlay {
background-color: rgba(0,0,0,0.3);
z-index: 999999;
}


body .tooltip {
z-index: 999999999;
}

#app .v--modal {
border-radius: 7px;
}
body #app .v--modal .el-table th,body #app .v--modal .el-table tr {
background-color: #f2f2f2;
}
body #app .v--modal .el-table td {
    border-bottom: 1px solid #e0e0e0;
}

body .card-collapse .card.introjs-showElement {
padding-bottom: 50px;
}

.card-collapse .card.introjs-showElement .card-header {
    padding: 1.75rem 1.75em;
	    border-radius: 9px;
	    }
body .introjs-tooltipReferenceLayer .introjs-tooltip, body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer  .introjs-tooltip {
 border-radius: 10px;
background-color: white;
 text-align: center;
     border: 2px solid #096b94dd;
     box-shadow: 6px 7px 20px 0px rgb(0 0 0 / 30%);
 }
body.dark #app .v--modal-overlay .carda {
background: black;
}
body .introjs-tooltipReferenceLayer .introjs-arrow.top { 
 display: none !important;
 }
body .introjs-tooltipReferenceLayer .introjs-tooltiptext { 
padding: 10px 30px 0px;
}
body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer .introjs-tooltiptext {
color: #2c3e50;
}
body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer .introjs-button.introjs-disabled, body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer .introjs-disabled:hover, body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer .introjs-disabled:focus {
color: #C2C2C2 !important;
    border-color: #d4d4d4;
    cursor: default;
    /* box-shadow: 0 2px 0px -0px #CACED1; */
    background-color: #E6E6E6;
    background-image: none;
    text-decoration: none;
}
body.app-page .introjs-helperLayer.modal-tour + .introjs-tooltipReferenceLayer .introjs-button {
    text-shadow: unset !important;
    color: #C2C2C2 !important
}


body .introjs-tooltipReferenceLayer .introjs-tooltip p.introHeader {
    font-size: 1em;
        color: brown;
	    font-weight: 700;
	        margin-bottom: 10px;
		}
body #app .v--modal-overlay .card:not(.card-pricing), body #app .v--modal-overlay .input-group-text {
background: #f2f2f2;
}
 body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-button:focus,body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-button:active{
	         color: white !important;
		 text-shadow: none;
		 }
 body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-nextbutton:hover,body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-prevbutton:hover{
	         color: white !important;
		 text-shadow: none;
		 }

 body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-donebutton:hover {
     background: #E65929;
         border-color: #B91D0D;
	         color: white !important;
		 text-shadow: none;
		 }
 body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-skipbutton:hover {
     background: #E65929;
         border-color: #B91D0D;
	         color: white !important;
		 text-shadow: none;
		 }

body .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-donebutton:not(.introjs-disabled) {
    background: transparent;
    border-color: gray;
    color: gray;
    text-shadow: none;
}
body.app-page .introjs-button.introjs-nextbutton:not(.introjs-disabled) {
    background: #23587A;
text-decoration: none;
    color: #fff !important;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-color: gray;
}
 body .introjs-helperLayer {
 border-radius: 10px;
      padding-top: 20px;
	    padding-bottom: 32px;
      margin-top: -20px;
	    }
 body .introjs-helperLayer.select {
	    margin-top: -44px;
	    padding-bottom: 68px;
 }
/*
main > * {
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1;
}

.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
*/
body #page>.page-overlay:after  {
opacity: 0;
display: block;
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: -1;
content: "";
background-color: rgba(0,0,0,1);
transition: opacity 0.3s;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
 
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
 
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
 
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
 
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
 
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
 
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
 
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

#app .v--modal button a {
color: white;
text-decoration : none;
}
  .invalid {
      border-color: red;
        }
body.app-page .tooltip-inner {
    -webkit-box-shadow: 0 5px 30px rgba(0,0,0,0.13);
    box-shadow: 0 5px 30px rgba(0,0,0,0.13);
    padding-bottom: 15px;
}
body .toasted-container {
    position: fixed;
        z-index: 1000000000;
        }
body .medium-editor-toolbar {
z-index: 999999999;
}

body.app-page .el-popper[x-placement^=bottom] .popper__arrow:after, body.app-page .el-popper[x-placement^=bottom] .popper__arrow:before {
    content: '';
    display: block;
    position: absolute;
    left: 100%;
    width: 0;
    height: 0;
    border-style: solid;
}
body.app-page .el-popper[x-placement^=bottom] .popper__arrow:before {
    top: -9px;
		left: -7px;
    border-color: transparent transparent  rgba(0,0,0,0.1) transparent;
    border-width: 7px;
}
body.app-page .el-select-dropdown.el-popper {
box-shadow: none;
border: 1px solid rgba(0,0,0,0.2);
margin-top: 0px;
}
body.dark.app-page .el-select-dropdown.el-popper.mode-popper {
box-shadow: none;
border: 1px solid #e8e8e84f;
background: #121212;
margin-top: 0px;
}
body.dark.app-page .el-select-dropdown.el-popper.mode-popper .el-select-dropdown__item.hover {
background-color: rgba(132, 132, 132, 0.19);
}
body.dark.app-page .el-popper[x-placement^=bottom] .popper__arrow:before {
    top: -9px;
		left: -7px;
    border-color: transparent transparent  #e8e8e84f transparent;
    border-width: 7px;
}
body.dark.app-page .el-popper.mode-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #121212;
    }

body .dropdown-menu {
box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
}
body.dark.app-page .el-popper[x-placement^=bottom] .popper__arrow {
border-bottom-color: #e8e8e84f;
}
body #nameDialog {
    width: 400px;
    border: 1px solid rgba(0,0,0,0.2);
    box-shadow: none;
    outline: none;
    height: 24px;
    padding: 2px 8px;
    border-radius: 5px;
}
body #nameDialog::outline {
box-shadow: none;
}
body #nameDialog::-moz-selection {
background: #418fc5;
color: white;
outline: #418fc5;
}
body #nameDialog::selection {
background: #418fc5;
color: white;
outline: #418fc5;
}
body.app-page .toasted-container {
z-index: 111;
}
body.isDesktop #app, body.isDesktop #page {
width: calc(100vw + 20px);
}
@media (min-width: 992px) {
body .container #selectWrapper {
font-size: 0.8em;
}
}
body .page-header .subtext a.btn p {
margin-bottom: 0;
}
body #app .box input[type=password], .box input[type=text] {
font-size: 14px;
font-weight: 700;
}
#endofFile {}


body.app-page .rightPanel{z-index:99;}
body .page-header:after,body page-header:before{z-index:100;}
body .page-header .page-header-image{z-index:100;}
#app #g25 .el-select.select-mode{margin-top:-30px;box-shadow:inset -3px 2px 20px 20px #f2f2f2aa;}
body.dark #app #g25 .el-select.select-mode{box-shadow:inset -3px 2px 20px 20px #00000008;}
#app #g25 .el-select.select-mode input{background-color:transparent;color:#4c4b4b96;text-transform:uppercase;font-weight:600;font-family:"Lato", "Helvetica Neue", Arial, sans-serif;}
body #app #g25 .el-select.select-mode input{padding-left:5px;padding-bottom:0;margin-top:-12px;}
body.dark #app #g25 .el-select.select-mode input{color:#ffffff96;}
body .el-select-dropdown.el-popper{font-family:"Lato", "Helvetica Neue", Arial, sans-serif;font-size:12px;}
body.dark .el-select-dropdown.el-popper.mode-popper{background:#5f5e5e;color:white;border:1px solid #E4E7ED;box-shadow:none;}
body.dark .el-select-dropdown.el-popper.mode-popper .el-select-dropdown__item:hover,body.dark .el-select-dropdown.el-popper.mode-popper .el-select-dropdown__item.hover{background-color:#3e3f41;}
body.dark .el-popper.mode-popper[x-placement^=bottom] .popper__arrow::after{border-bottom-color:#5f5e5e;}
body.dark .el-select-dropdown.el-popper.mode-popper .el-select-dropdown__item:not(.selected){color:white;}
#app #g25 .el-select.select-mode input.el-input__inner:hover{background-color:transparent;box-shadow:none;}
.label.selectSamples{margin-top:15px;position:relative;float:left;cursor:default;}
.optimafit .el-switch,.selectSamples .el-switch{margin-left:12px;margin-top:-4px;margin-right:5px;}
.optimafit .el-switch.is-checked .el-switch__core,.selectSamples .el-switch.is-checked .el-switch__core{border-color:#2b88af;background-color:#3480a0;}
body .el-drawer__wrapper{z-index:105 !important;}
body .el-drawer{box-shadow:none;}
body .el-drawer__close-btn{font-size:32px;position:absolute;top:85px;z-index:999;right:15px;}
body.isMobile .el-drawer__close-btn {
    top: 60px;
    right: 0px;
}
body input.otp-input {
font-size: 16px !important;
}
body .el-drawer__header{padding:none;}
body .el-drawer__body{background-color:var(--bg-color);overflow-y:scroll;width:calc(100% + 20px);}
body.dark .el-drawer__body{background-color:var(--bg-color);}
body .el-drawer{background-color:var(--bg-color);}
.rightPanel .layout{border-top:1px solid #80808040;padding-top:24px;}
.rightPanel-items{padding:100px 10px 10px 10px;}
.rightPanel-container .bootstrap-switch,.rightPanel-container .el-switch{position:relative;display:block;margin-left:auto;margin-right:8px;margin-top:-4px;margin-bottom:40px;}
.rightPanel .el-switch__label{color:gray;}
.rightPanel span.label.theme{margin-top:20px;}
.el-switch__label *{font-size:10px;}
.el-switch__label.is-active{color:#409EFF;font-weight:700;}
.rightPanel .vue-slider{margin:10px 30px 50px 20px;}
.rightPanel span.slider-value{float:right;margin-right:30px;font-size:1.2em;color:#8a8888b3;font-weight:700;}
.rightPanel .vue-slider-mark-label{font-size:10px;color:gray;}
.rightPanel .slider-label{font-size:0.7em;margin-left:20px;color:gray;text-transform:uppercase;}
.rightPanel span.label{font-size:0.7em;display:flex;margin-left:20px;color:gray;text-transform:uppercase;}
.rightPanel-container .bootstrap-switch.bootstrap-switch-on{background-color:#4466ae;}
.rightPanel-container .bootstrap-switch.bootstrap-switch-off{background-color:#efefef;color:gray;}
.rightPanel-container .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default{color:black;}
.rightPanel-container .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label{background-color:white;}
.multiselect,.multiselect__input,.multiselect__single{font-size:12px;line-height:12px;}
#app .multiselect__option--group{background:#669dc320;}
.multiselect__option--disabled{display:none !important;}
#app .multiselect__tag-xxx-icon{border-radius:none;}
#app .multiselect__tag-xxx-icon:hover{background:#cc0202;}
#app .multiselect__tag-xxx-icon:after{color:#ffffff8f;}
#app .multiselect__tag-xxx-icon:hover:after{color:#ffffff;}
#app .multiselect__option--selected #app .multiselect__option--group:hover{color:white;}
#app #selectWrapper .multiselect .multiselect__option--group>span:after{content:" - select entire group ";margin-left:2px;}
#selectWrapper .multiselect__content-wrapper{overflow-x:hidden;box-shadow:-5px 4px 9px -6px #00000052;}
#app .leftSelect .multiselect__tag.outlier,#app .rightSelect .multiselect__tag.outlier{background-color:#dd4b39;}
#app .rightSelect .multiselect__tag.default{background-color:#2e668c;}
#app #g25 .multiselect__tag.default.user{background-color:rgba(46, 102, 140, 1);color:#f9f9f9;border:1px solid #2e668c4f;}
#app #g25 .multiselect__tag.default.calc{background-color:#E65929;color:#f9f9f9;border:1px solid #2e668c4f;}
body.dark #app #g25 #selectWrapper .multiselect__tag.default.calc{background-color:#E65929;}
.multiselect .calcOptions{font-weight:700;}
.multiselect .calcOptionsDesc{margin-top:8px;font-style:italic;}
.leftSelect .multiselect__tag,.leftSelect .multiselect__option--highlight:after,.leftSelect .multiselect__spinner:after,.leftSelect .multiselect__spinner:before,.leftSelect .multiselect__option--highlight{border-top-color:#828483;background:#2e668c;font-weight:700;font-size:10px;line-height:1.6;}
.leftSelect .multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;}
.leftSelect .multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;display:none;}
.leftSelect .multiselect__option--selected.multiselect__option:after{background:#ff6a6a;display:none;}
.leftSelect .multiselect__option:after{background:#ff6a6a;display:none;}
.leftSelect .multiselect__.ag_icon:after{color:white;}
.leftSelect .multiselect__.ag_icon:focus,.leftSelect .multiselect__.ag_icon:hover{background:#116f65;color:white;}
.rightSelect .multiselect__tag,.rightSelect .multiselect__option--highlight:after,.rightSelect .multiselect__spinner:after,.rightSelect .multiselect__spinner:before,.rightSelect .multiselect__option--highlight{border-top-color:#2e294e;background:#2e294e;background:#418fc5;font-weight:700;font-size:10px;line-height:1.6;}
.rightSelect .multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff;}
.rightSelect .multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;display:none;}
.rightSelect .multiselect__option--selected.multiselect__option:after{background:#ff6a6a;display:none;}
.rightSelect .multiselect__option:after{background:#ff6a6a;display:none;}
.rightSelect .multiselect__.ag_icon:after{color:white;}
.rightSelect .multiselect__.ag_icon:focus,.rightSelect .multiselect__.ag_icon:hover{background:#222222;color:white;}
#app #g25 .multiselect__input,#app #g25 .multiselect__single{font-size:12px;text-transform:uppercase;}
#app #g25 .multiselect__option{display:block;padding:8px;line-height:12px;min-height:30px;}
#app #g25 .multiselect__option--highlight{background:#2e668c;outline:none;font-size:12px;color:white;}
#app #g25 .multiselect__option--selected.multiselect__option--highlight,#app #g25 .multiselect__option--group-selected.multiselect__option--highlight{background:#dd4b39;font-size:12px;}
#app #selectWrapper .multiselect .multiselect__option--group-selected>span:after{content:" - unselect group ";margin-left:2px;}
#app #g25 .multiselect__content-wrapper{width:87%;left:3%;}
#app #g25 .multiselect__tags{transition:background .3s;font-size:12px;text-align:left;padding-left:10px;padding-top:9px;padding-bottom:2px;}
#app #g25.nmonte .multiselect__tags{border:1px solid #0606065e;border-style:solid;}
#app #g25.nmonte .multiselect__select:before{top:60%;}
#app #g25 .multiselect__tags .multiselect__tag{cursor:default;}
#app #g25 .multiselect__tags .multiselect__placeholder{font-size:12px;padding-top:3px;padding-left:5px;position:absolute;text-transform:uppercase;}
#app #g25 .multiselect__tags *::placeholder{color:#adadad;opacity:1;}
#app #g25 .multiselect.white .multiselect__tags{background:#fff;}
#app #g25 .multiselect__tag{margin-right:7px;margin-bottom:6px;-webkit-box-shadow:-7px 7px 6px -6px rgba(0, 0, 0, .32);box-shadow:-7px 7px 16px -6px rgba(0, 0, 0, .32);padding:4px 26px 4px 10px;}
body.dark #app,body.dark #page,body.dark #g25,body.dark .rightPanel-container{background:#181818;}
body.dark #app #g25 .multiselect__tags{box-shadow:-7px 7px 6px -6px #00000052;-webkit-transition:background .3s;transition:background .3s;font-size:12px;text-align:left;border:1px solid #8c8c8c5e;padding-left:12px;padding-top:12px;padding-bottom:3px;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #selectWrapper .multiselect__option--group{background:#414141;color:white;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect__option--selected{background:#5f5e5eba;color:white;font-weight:700;font-style:italic;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect.white .multiselect__tags{background:#1e1e1e;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect__tags{box-shadow:-7px 7px 6px -6px #00000052;transition:background .3s;font-size:12px;text-align:left;border:1px solid #ffffff47;padding-left:12px;padding-top:12px;background:#121212;background:#0000006b;padding-bottom:3px;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect__content-wrapper{background:#5f5e5e;color:white;width:90%;border:1px solid gray;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body #app #g25 #selectWrapper .multiselect__input,body #selectWrapper  .multiselect__single{position:relative;max-width:320px;}
body.dark #app #g25 #selectWrapper .multiselect__input,body.dark #selectWrapper  .multiselect__single{background:#00000000;color:white;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark .rightPanel  .el-switch__core,body.dark #selectWrapper  .el-switch__core{border:1px solid #dcdfe68c;background:#dcdfe670;transition:border-color .3s,background-color .3s;}
body.dark .rightPanel .el-switch.is-checked .el-switch__core,body.dark #selectWrapper .el-switch.is-checked .el-switch__core{border-color:#409EFF70;background-color:#409EFF;}
body.dark .rightPanel{border-left:1px solid #c0c0c05c;border-left-width:1px;border-left-style:solid;border-left-color:rgba(192, 192, 192, 0.36);}
body.dark #app #g25 #selectWrapper .multiselect__tag,body.dark #selectWrapper .multiselect__option--highlight:after,body.dark #selectWrapper .multiselect__spinner:after,body.dark #selectWrapper .multiselect__spinner:before,body.dark #selectWrapper .multiselect__option--highlight{border-top-color:#2e294e;background:#44434b;background:#a61616;background:#418fc5;font-size:10px;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark .show.showPanel  .rightPanel{box-shadow:0px 0px 15px 0px rgba(62, 77, 95, 0.42);}
body.dark .rightPanel-background{background:rgba(0, 0, 0, 0);z-index:-1;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark  .rightPanel{background:#121212;color:white;}
body.dark .rightPanel .slider-label,body.dark .rightPanel span.label{color:white;}
body.dark #app #g25 #selectWrapper .multiselect__tag.default{background-color:#2e668c;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect__tag.default.user{background-color:rgb(63, 78, 97);color:#ffffff;transition:color 0.3s, background 0.3s, background-color 0.3s;}
body.dark #app #g25 #selectWrapper .multiselect__option--selected.multiselect__option--highlight,body.dark #app #g25 #selectWrapper .multiselect__option--group-selected.multiselect__option--highlight{background:#dd4b39;color:white;}
body #app #g25 .header-rotated-componenta .ag-xxx-cell-label-container .ag-xxx-header-cell-text{height:150%;text-align:right;}
body #app #g25 .header-rotated-component .ag-xxx-cell-label-container{position:absolute;bottom:0;transform-origin:bottom;transform:rotate(-45deg);margin-bottom:13px;}
body #app #g25 #table .switchChartType .el-switch.is-checked .el-switch__core{border-color:#ffffff;background-color:#0a78c6dd;}
body #app #g25 #table .switchChartType .el-switch{margin-left:0px;font-size:0.75em;}
body #app #g25 .multiselect--active .fa.download{display:none;}
#app #g25 .multiselect__tags .multiselect__tag{max-width:60%;}
.leftSelect i.fa-edit{display:inline;float:right;position:relative;top:-30px;right:10px;font-size:20px;cursor:pointer;}
.leftSelect i.fa-edit:hover::before,.rightSelect i.fa-edit:hover::before,.rightSelect i.fa-plus:hover::before{opacity:1;}
#app #g25 .leftSelect i.addremove:hover{opacity:1;}
.leftSelect i.fa-edit:hover{color:#00abff;}
.leftSelect{padding:0 50px 0 50px;max-width:50%;margin-left:0px;flex:1 0 auto;}
#app #g25 .leftSelect .label.add:hover{color:steelblue;}
#app #g25 .leftSelect i.fa-plus.addremove{margin-left:-30px;font-size:1.2em;font-weight:700;line-height:1em;width:50px;text-align:right;}
#app #g25 .leftSelect i.addremove{top:0;right:unset;cursor:pointer;margin-left:15px;color:steelblue;opacity:0.3;transition:opacity 0.3s;}
body.dark #app #g25 .leftSelect .label.add:hover{color:white;}
#app #g25 .leftSelect  #leftLabel .label.add{right:0;top:0;}

body #app .el-drawer__body { overflow-x: hidden; }
.ag-xxx-theme-balham *::-webkit-scrollbar{width:0 !important;}
.ag-xxx-theme-balham *{overflow:-moz-scrollbars-none;}
#app .multiselect__tag-xxx-icon{border-radius:none;}
#app .multiselect__tag-xxx-icon:hover{background:#cc0202;}
#app .multiselect__tag-xxx-icon:after{color:#ffffff8f;}
#app .multiselect__tag-xxx-icon:hover:after{color:#ffffff;}
#app .ag-xxx-theme-balham{width:72%;margin-left:13%;margin-right:14%;margin-bottom:50px;background:#f2f2f2;font-family:Lato, Helvetica Neue, Arial, sans-serif;transition:height 0.5s linear;}
#app #grid.shrink .ag-xxx-theme-balham{height:70% !important;}
#app .ag-xxx-theme-balham:not(.rotated) .ag-xxx-header-cell-label{justify-content:center;color:white;}
body #app .ag-xxx-root-wrapper{background:transparent;border:0px solid transparent;}
body #app .ag-xxx-root-wrapper-body{margin-bottom:50px;}
body #app .ag-xxx-theme-balham .ag-xxx-ltr .ag-xxx-cell.cell-sheet{border-left:1px solid #ffffff1a;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-ltr .ag-xxx-cell.cell-sheet{border-left:1px solid #00000010;}
body #app .ag-xxx-theme-balham .cell-fit{background-color:#f2f2f2;color:#656565;border-right:1px solid #80808033;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-ltr .ag-xxx-cell.cell-sheet{border-left:1px solid #ffffff0f;background-color:#7372721d;}
#app .ag-xxx-theme-balham .ag-xxx-header{background-color:#f2f3f2;}
#app .ag-xxx-theme-balham .ag-xxx-row-odd{background-color:rgba(113, 113, 113, 0.1);background-color:#f2f2f2;background-color:rgba(113, 202, 255, 0.2);background-color:white;}
#app .ag-xxx-theme-balham .ag-xxx-row-even{background-color:rgba(113, 113, 113, 0.05);background-color:rgba(113, 202, 255, 0.2);background-color:white;}
.ag-xxx-theme-balham .ag-xxx-row{border-color:#00000052;border-color:#f2f2f2;border-color:#00000020;}
body #app #g25 #result.nmonte .ag-xxx-theme-balham .ag-xxx-row:hover{background-color:rgba(113, 202, 255, 0.5) !important;}
body #app #g25 #result.nmonte .ag-xxx-theme-balham .ag-xxx-row.ag-xxx-row-selected{border-top:2px solid white !important;border-bottom:2px solid white !important;font-weight:700;font-style:italic;}
#app .ag-xxx-theme-balham .ag-xxx-cell{color:#2c2c2c;transition-property:background-color;transition-duration:.5s;transition-timing-function:ease;border-left:1px solid #ffffff;}
#app .ag-xxx-theme-balham .ag-xxx-cell:focus{border:transparent;}
#app .ag-xxx-theme-balham .ag-xxx-header-cell{transition-property:all;transition-duration:.3s;transition-timing-function:ease;}
#app .ag-xxx-theme-balham .ag-xxx-root{border-radius:5px;border-color:#f2f2f2;}
.ag-xxx-cell.distance-poor:after{color:#ff4444;color:tomato;font-weight:900;float:right;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;content:"•";-webkit-font-smoothing:antialiased;font-weight:900;font-size:2.5em;margin-right:2px;margin-top:-4px;}
.ag-xxx-cell.distance-bad:after{color:gray;font-weight:900;float:right;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;-webkit-font-smoothing:antialiased;content:"•";font-weight:900;font-size:2.5em;margin-right:2px;margin-top:-4px;}
.ag-xxx-cell.distance-fair:after{color:#e4b91a;font-weight:900;float:right;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;-webkit-font-smoothing:antialiased;content:"•";font-weight:900;font-size:2.5em;margin-right:2px;margin-top:-4px;}
.ag-xxx-cell.distance-good:after{color:green;content:"•";font-weight:900;font-size:2.5em;margin-right:2px;margin-top:-4px;float:right;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;-webkit-font-smoothing:antialiased;}
body.dark #app .ag-xxx-theme-balham{background:#181818;color:white;font-family:Lato, Helvetica Neue, Arial, sans-serif;transition:height 0.5s linear;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-header{background-color:black;color:white;border:1px solid white;}
body #app .ag-xxx-theme-balham .ag-xxx-header{background-color:#2e668c;color:#000000a9;color:white;border:1px solid white;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-row-odd{background-color:#042022;background:hsla(210, 25%, 10%, 1);color:white;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-row-even{background-color:#042022;background:hsla(210, 25%, 10%, 1);color:white;}
body.dark .ag-xxx-theme-balham .ag-xxx-row{border-color:rgba(255,255,255,0.21);color:white;}
body.dark #app #g25 #result.nmonte .ag-xxx-theme-balham .ag-xxx-row-selected{border-top:1px solid white !important;border-bottom:1px solid white !important;color:white;font-weight:700;font-style:italic;}
body.dark #app #g25 #result.nmonte .ag-xxx-theme-balham .ag-xxx-row:hover{background-color:#d83904 !important;color:white;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-cell{color:white;}
body.dark #app .ag-xxx-theme-balham .cell-sheet{color:white !important;}
body.dark #app .ag-xxx-theme-balham .ag-xxx-root{border-radius:3px;border:1px solid white;}
body #app .ag-xxx-theme-balham .ag-xxx-root{border-radius:3px;border:1px solid #2e66833d;}
body.dark #app .ag-xxx-theme-balham .cell-sample{background-color:black;}
body.dark #app .ag-xxx-theme-balham .cell-fit{background-color:#121212;border-right:white;}
body #app .ag-xxx-theme-balham .cell-sample{background-color:white;color:black;}
body #app .ag-xxx-theme-balham{width:80%;margin-left:7.5%;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-header{border:none;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-pinned-left-header{border:none;}
body.app-page #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-header{background-color:transparent;}
body #app #g25 .ag-xxx-theme-balham.rotated{width:calc(72% + 150px);background:transparent;border-radius:3px;position:absolute;margin-top:-32px;}
body.dark #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-body-viewport .ag-xxx-row-first{border-top:none;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-body-viewport{border:1px solid #00000040;border-top:1px solid #00000020;padding-top:1px;border-radius:3px;box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.4);width:calc(100% - 150px);}
body.dark #app #g25 .ag-xxx-theme-balham.rotated{background:#181818;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-header-cell{color:#444444;font-weight:600;}
body.dark #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-header-cell{color:white;border-bottom:none;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-pinned-left-cols-container{border-right:1px solid gray;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-root{border:none;}
body.dark #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-center-cols-viewport .ag-xxx-cell{border-right:none;border-left:none;}
body #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-center-cols-viewport .ag-xxx-cell{border-right:none;}
body.dark #app #g25 .ag-xxx-theme-balham.rotated .ag-xxx-body-viewport{border:1px solid white;border-radius:3px;}
body #app .ag-xxx-theme-balham.rotated .ag-xxx-header-cell::after,body .ag-xxx-theme-balham.rotated .ag-xxx-header-group-cell::after{height:0;}
body #app #g25 .header-rotated-component .ag-xxx-header-cell-label{height:100%;padding:0 !important;}
body #app #g25 .rotated- .ag-xxx-header-cell-label .ag-xxx-header-cell-text{overflow:initial;text-overflow:initial;display:inline-block;}
body #app #g25 .ag-xxx-header{width:calc(100% + 100px) !important;}
body #app #g25 .ag-xxx-header .ag-xxx-header-container,body #app #g25 .ag-xxx-header .ag-xxx-header-container .ag-xxx-header-row{width:100% !important;}
body #app #g25 .header-rotated-componenta .ag-xxx-cell-label-container .ag-xxx-header-cell-text{height:150%;text-align:right;}
body #app #g25 .header-rotated-component .ag-xxx-header-cell-text{position:absolute;text-align:right;bottom:0;left:50%;z-index:999;}
body #app #g25 .header-rotated-component .ag-xxx-cell-label-container{position:absolute;bottom:0;transform-origin:bottom;transform:rotate(-45deg);margin-bottom:13px;}
body #app #g25 .ag-xxx-theme-balham.rotated .header-sample,body #app #g25 .ag-xxx-theme-balham.rotated .header-fit{height:40px;bottom:0px;position:absolute;}
body #app #g25 .ag-xxx-theme-balham.rotated .header-sample .ag-xxx-header-cell-label .ag-xxx-header-cell-text,body #app #g25 .ag-xxx-theme-balham.rotated .header-fit .ag-xxx-header-cell-label .ag-xxx-header-cell-text{overflow:visible;text-overflow:unset;}
body #app #g25 .ag-xxx-theme-balham .ag-xxx-icon.ag-xxx-icon-asc,body #app #g25 .ag-xxx-theme-balham .ag-xxx-icon.ag-xxx-icon-desc{display:none;}
body #app #g25 #result.nmonte .ag-xxx-theme-balham .ag-xxx-center-cols-viewport{overflow-x:hidden;}
#app .ag-xxx-theme-balham:not(.rotated) .ag-xxx-header-cell-label{color:white;}
#app .ag-xxx-theme-balham .ag-xxx-header-cell-label{justify-content:center;}
body #app .ag-xxx-root-wrapper{background:transparent;border:0px solid transparent;}
body #app #g25 .ag-xxx-theme-balham .ag-xxx-tooltip{background-color:white;color:black;border-radius:5px;padding:15px;border-style:solid;border-color:transparent;}
body #app #g25 .ag-xxx-theme-balham div.ag-xxx-popup{margin:0;}
body.dark #app #g25 .ag-xxx-theme-balham .ag-xxx-tooltip{background-color:#000000bb;color:white;border-radius:5px;padding:15px;border-width:2px;border-style:solid;border-color:#ffffffaa;}
body #app #g25 #table .lowerContainer.hideshared .ag-xxx-tooltip{display:none;}
body #app #g25 #result.nmonte .lowerContainer.hideshared .ag-xxx-theme-balham .ag-xxx-row:hover{background-color:unset !important;}
body.dark #app #g25 #result.nmonte .lowerContainer.hideshared .ag-xxx-theme-balham .ag-xxx-row:hover{background-color:#131920 !important;}
body #app #g25 #table #grid .ag-xxx-count{margin-right:7px;margin-left:0px;padding:2px 5px 1px 5px;font-size:0.95em;line-height:20px;text-align:center;font-weight:700;border-radius:5px;min-height:20px;background:unset;color:white;border-left:1px solid silver;border-right:1px solid silver;}
body.dark #app #g25 #table #grid .ag-xxx-theme-balham.rotated .ag-xxx-count{background:unset;color:white;border-left:1px solid silver;border-right:1px solid silver;}
body #app #g25 #table #grid .ag-xxx-theme-balham.rotated .ag-xxx-count{background:unset;color:black;border-left:1px solid gray;border-right:1px solid gray;}
body .ag-xxx-tooltip-count{padding:2px 5px 1px 5px;background:#2e668c;color:white;font-size:0.95em;line-height:20px;text-align:center;font-weight:700;border-radius:5px;margin-right:8px;}
body.dark .ag-xxx-tooltip-count{background:white;color:brown;}
body #app #page.fullscreen .ag-xxx-theme-balham.rotated .ag-xxx-header{position:fixed;z-index:99999;background:#f2f2f2;}
body.dark #app #page.fullscreen .ag-xxx-theme-balham.rotated .ag-xxx-header{background:#181818;}
body #app #page.fullscreen #table .lowerContainer.hideshared .ag-xxx-theme-balham.rotated .ag-xxx-header{background:transparent;}
body #app #page.fullscreen .ag-xxx-theme-balham.rotated{margin-top:100px;}
body #app #page.fullscreen .ag-xxx-theme-balham .ag-xxx-header{position:fixed;top:var(--mainHeaderSpacer);z-index:99999;}
body #app #page.fullscreen .ag-xxx-theme-balham .ag-xxx-header{background-color:transparent;}
body.dark #app #page.fullscreen .ag-xxx-theme-balham .ag-xxx-header{border:none;}
body #app #page.fullscreen .ag-xxx-theme-balham .ag-xxx-header-cell{background-color:#2e668c;}
body.dark #app #page.fullscreen .ag-xxx-theme-balham .ag-xxx-header-cell{background-color:black;border-left:1px solid white;border-top:1px solid white;border-right:1px solid white;}
body #app #page.fullscreen .ag-xxx-theme-balham.rotated .ag-xxx-header-cell{background-color:transparent;border:none;}
body:not(.dark) #app #g25 .results.expanded .ag-xxx-theme-balham.rotated .ag-xxx-body-viewport{padding-top:12px;}
body .geno-default-icons:before {
margin-left: -7px;
margin-right: 8px;
    }
body #pricing .geno-default-icons:before {
margin-left: 8px;
margin-right: 8px;
    }
body #app #submodal .section-image .card-plain h6.category {
line-height: 38px;
font-size: 1em;
}
body .v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;
    display: inline;
    float: right;
    z-index: 9;
}
#app .rotateLoading {
    animation: rotation 0.7s infinite linear;
    box-shadow: none !important;
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(359deg);
    }
}
body .v-context {
font-size: 0.9em;
line-height: 0.9em;
}
body #app.prerender #navparent {
display: none;
}
body #app.prerender {
margin-left: -8px;
margin-top: -8px;
}
body #app.prerender .signup p {
margin: 0;
}
body #app .btn {
text-transform: uppercase;
}

body.app-page .tooltip:not(.modaltip) .tooltip-inner {
    border-radius: 5px !important;
    border: 1px solid rgba(255,255,255,1) !important;
background-color: rgba(0,0,0,0.8) !important;
color: white !important;
}
body.isMobile {
  width: 100vw !important;
  height: 100vh;
}

body.isMobile .v--modal-overlay .v--modal-box.v--modal {
  width: calc(100% - 30px) !important;
  left: 15px !important;
  margin-bottom: 15px;
  top: 15px !important;
  width: -webkit-calc(100% - 75px) !important;
  width: -moz-calc(100% - 30px) !important;
  overflow: auto;
}
body.isMobile .v--modal-overlay .v--modal-box.v--modal .history-modal-content {
min-width: 800px;
}


body.isMobile #app #navparent #userprofile .v--modal-box {
  top: 15px !important;
  left: 15px !important;
  width: calc(100vw - 30px) !important;
  height: calc(100vh - 30px) !important;
  overflow-y: scroll;
  width: -webkit-calc(100vw - 30px) !important;
  width: -moz-calc(100vw - 30px) !important;
  height: -webkit-calc(100vh - 30px) !important;
  height: -moz-calc(100vh - 30px) !important;
}
body.isMobile #tosmodal .v--modal-box {
width: 100vw !important;
height: 100vh !important;
left: 0 !important;
    top: 0 !important;
    margin-bottom: 0;
}
body.isMobile #tos.genoplot-tos-content {
    padding: 20px;
    font-size: 0.7em;
    margin-right: -30px;
}
body.isMobile .v--modal-overlay .v--modal-box.v--modal li {
    padding-left: 10px !important;
}
body.isMobile .v--modal-overlay .v--modal-box.v--modal ul {
    padding-inline-start: 10px !important;
}

body.isMobile #tosmodal .v--modal-box .scroll-area {
padding-right: 5px;
}
body.isMobile #tosmodal .v--modal-box .ps__rail-x, body.isMobile #tosmodal .v--modal-box .ps__rail-y {
display: none;
}

body.isMobile .genoplot-tos-content,
body.isMobile .genoplot-aboutus-content,
body.isMobile .genoplot-conduct-content
{
  padding: 20px;
}

body.isMobile .genoplot-tos-content {
  height: calc(100vh - 150px);
  height: -webkit-calc(100vh - 200px);
  height: -moz-calc(100vh - 150px);
}
body.isMobile .genoplot-aboutus-content {
  height: calc(100vh - 150px);
  height: -webkit-calc(100vh - 200px);
  height: -moz-calc(100vh - 150px);
}
body.isMobile .genoplot-conduct-content {
  height: calc(100vh - 150px);
  height: -webkit-calc(100vh - 200px);
  height: -moz-calc(100vh - 150px);
}
body.isMobile .genoplot-conduct-content .content {
    white-space: pre-wrap;
        height: calc(100% - 50px);
            overflow: auto;
            }
body.isMobile .genoplot-conduct-content .buttons {
    margin-top: 8px;
    font-size: 1.1em;
}

body.isMobile .scroll-area {
  width: 100%;
  height: 87vh;
}
body.isMobile .ps--active-x>.ps__rail-x, body.isMobile .ps--active-y>.ps__rail-y {
display: none;
}

body.nav-open.isMobile #page-overlay {
  display: none;
}

body.isMobile #app #userprofile label.btn-info,
body.isMobile #userprofile .btn.btn-round.btn-primary.btn-md {
  margin-left: 10px;
}

body.isMobile #app,
body.isMobile #page {
  max-width: 100vw;
}

body.isMobile #pricing .geno-default-icons:before {
  margin-left: 0;
  margin-right: 0;
}

body.isMobile #statusLogo > * {
  margin: 2px -7px !important;
}

body.isMobile .Section__sectionBody___ihqqd,
body.isMobile .Section__sectionFooter___1T54C {
  max-width: 100%;
}

body.isMobile .box,
body.isMobile .box .box-part {
  width: 100%;
}

body.isMobile #userprofile .vue-profile {
  margin: auto;
  width: 100% !important;
  padding: 10px;
}

body.isMobile #about .container > .row:nth-child(4) {
  flex-direction: column-reverse;
}

body.isMobile .box {
  overflow-y: scroll;
  height: calc(100vh - 30px) !important;
  height: -webkit-calc(100vh - 30px) !important;
  height: -moz-calc(100vh - 30px) !important;
}

body.isMobile .box .box-part#bp-right {
  border-left: none;
  height: 400px;
}

body.isMobile .box #bp-left.box-part {
  height: unset;
}

body.isMobile .Form__formSection___1PPvW {
  margin-bottom: 50px;
}

body.isMobile #app .navbar .container .navbar-brand.home {
  padding-left: 25px;
}

body.isMobile #app .navbar .navbar-translate > .navbar-brand {
  padding-left: 0px;
}

body.isMobile #app div.credits {
  margin-left: 0;
}

body.isMobile #loginmodal.mobile #auth div.error {
  left: 0;
  right: unset;
  width: 100%;
  padding: 0 25px;
}

body.isMobile .section-space {
  height: 25px;
}

body.isMobile .mt-5,
body.isMobile .my-5 {
  margin-top: 1rem!important;
}

body.isMobile.presentation-page.frontpage #app #page .info {
  padding-top: 20px;
}

body.isMobile [class*=contactus-],
body.isMobile [class*=features-],
body.isMobile [class*=pricing-],
body.isMobile [class*=projects-],
body.isMobile [class*=team-],
body.isMobile [class*=testimonials-] {
  padding: 40px 0;
}

body.isMobile.presentation-page #app .rellax-text-container {
  top: 15%;
}

body.isMobile.presentation-page #app .subtext .h3-description {
  margin-right: 0;
  margin-top: 100px;
}



body.isMobile .row {
  margin-right: 0;
  margin-left: 0;
}

/*g25*/

body.isMobile #app #selectWrapper .leftSelect,
body.isMobile #app #selectWrapper .rightSelect {
  max-width: 100%;
}

body.isMobile.nmonte-container #app #selectWrapper .leftSelect,
body.isMobile.nmonte-container #app #selectWrapper .rightSelect {
  margin-bottom: 10px;
}

body.isMobile #editmodal .el-select .el-input .el-input__inner {
  width: unset;
}

body.isMobile #editmodal span.title {
  font-size: 12px;
  right: 77%;
}

body.isMobile .el-select .el-input .el-input__inner {
  padding: 11px 15px;
}

body.isMobile .el-select {
  width: unset !important;
}

body.isMobile label:not(.email,.labelquantity) {
  width: 75%;
  margin-left: 25%;
}

body.isMobile .vf-field-pristine .col-6 {
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: 0;
  padding-left: 0;
}

body.isMobile #ghostmodal span.radiobuttons {
  flex-direction: column;
  height: 100%;
  margin-bottom: 20px;
  margin-left: 70px;
}

body.isMobile #ghostmodal.fullscreen div.label {
  width: 80px;
  padding-right: 10px;
  font-size: 12px;
}

body.isMobile #ghostmodal.fullscreen .ancestry-container div.label,
body.isMobile #ghostmodal.fullscreen .base-container div.label {
  width: 80px;
}

body.isMobile #ghostmodal.fullscreen .base-container {
  padding-left: 0;
}

body.isMobile #ghostmodal .el-switch {
  margin-left: 80px;
}

body.isMobile #ghostmodal.fullscreen .infomsg {
  margin-left: 80px;
}

body.isMobile #ghostmodal.fullscreen .form-group,
body.isMobile #ghostmodal.fullscreen .input-group {
  margin-left: 80px;
  max-width: 60%;
}

body.isMobile #app #ghostmodal #ghost .buttons {
  padding: 10px 10px 30px 10px;
}

body.isMobile #ghostmodal.fullscreen .slide {
  padding: 10px 0px;
}

body.isMobile #app .app-page #ghostmodal .multiselect__content-wrapper {
  width: 100%;
  left: 0%;
}

body.isMobile #calcmodal.fullscreen div.label {
  width: 80px;
  font-size: 12px;
  position: relative;
}

body.isMobile #calcmodal.fullscreen .form-group,
body.isMobile #calcmodal.fullscreen .input-group {
  margin-left: 80px;
  max-width: 65%;
}

body.isMobile #calcmodal .el-switch.public {
  margin-left: 80px;
}

body.isMobile #calcmodal .fields > .switchgroup:nth-child(1) {
  margin-left: 20px !important;
  min-width: calc(100vw - 80px) !important;
  position: relative !important;
  height: unset !important;
  margin-top: 0 !important;
  margin-bottom: 140px;
  min-width: -webkit-calc(100vw - 80px) !important;
  min-width: -moz-calc(100vw - 80px) !important;
}

body.isMobile #calcmodal .fields > .switchgroup:nth-child(2) {
  margin-left: 20px !important;
  min-width: calc(100vw - 80px) !important;
  margin-top: 0 !important;
  height: 50px !important;
  left: 0;
  bottom: 90px;
  min-width: -webkit-calc(100vw - 80px) !important;
  min-width: -moz-calc(100vw - 80px) !important;
}

body.isMobile #calcmodal .fields > .switchgroup:nth-child(3) {
  margin-left: 20px !important;
  min-width: calc(100vw - 80px) !important;
  margin-top: 0 !important;
  height: 50px !important;
  left: 0;
  bottom: 45px;
  min-width: -webkit-calc(100vw - 80px) !important;
  min-width: -moz-calc(100vw - 80px) !important;
}

body.isMobile #calcmodal.fullscreen .container.calc {
  margin-top: 120px;
}

body.isMobile #calcmodal .slidergroup {
  display: block;
  width: 100%;
  position: relative;
  padding-left: 0 !important;
  margin: 0 0 60px 0;
  left: 0;
}

body.isMobile #calcmodal .vue-slider {
  display: block;
  width: 100%;
  position: relative;
}

body.isMobile #calcmodal .switchgroup .el-switch {
  position: relative !important;
  left: 0 !important;
  height: 20px !important;
  width: 100% !important;
}

body.isMobile #calcmodal .vue-slider {
  left: 0 !important;
  width: 100% !important;
}

body.isMobile #calcsamplesmodal.fullscreen .v--modal {
  height: calc(100vh - 30px) !important;
  overflow-y: scroll;
  height: -webkit-calc(100vh - 30px) !important;
  height: -moz-calc(100vh - 30px) !important;
}

body.isMobile #calcmodal .fields .fields {
  position: relative;
  height: unset !important;
}

body.isMobile #calcmodal.fullscreen .infomsg,
body.isMobile #calcmodal.fullscreen .validmsg,
body.isMobile #calcmodal.fulscreen .errmsg {
  margin-left: 0px;
  max-width: 100%;
  padding-left: 0;
}

body.isMobile #calcsamplesmodal .component-container .swiper-slide .el-switch.groupSamples {
  left: 20px;
  bottom: 75px;
}

body.isMobile #calcmodal .component-container .fields {
  min-height: 66px;
}

body.isMobile #calcmodal .label .subtext {
  right: 8px;
  top: -3px;
  width: unset;
}

body.isMobile #calcmodal.fullscreen .slide {
  padding: 10px 0;
}

body.isMobile #calcsamplesmodal .fields.customdata>div {
  padding-right: 0;
}

body.isMobile #app .multiselect__content-wrapper {
  width: 100% !important;
  left: 0 !important;
}

body.isMobile #samplesmodal.fullscreen .row {
  margin-bottom: 20px;
}

body.iasMobile .introjs-tooltipReferenceLayer .introjs-tooltip {
  margin-top: 0 !important;
  bottom: 0;
  transform: translateY(100%);
  top: unset !important;
}

body.isMobile .rightPanel-items {
  padding: 100px 0px 80px 10px;
}

body.isMobile .rightPanel .slider-label,
body.isMobile .rightPanel span.label {
  margin-left: 10px;
}

body.isMobile .card-body {
  padding: 0;
}

body.isMobile #editmodal .el-switch {
  margin-bottom: 15px;
}

body.isMobile #calcmodal .multiselect.right {
  margin: 20px 0;
}

/*admix*/

body.isMobile.calc #g25.calculator .section.filters,
body.isMobile #app #g25.calculator .leftSelect {
  max-width: 100%;
  margin-left: 0;
  width: 100%;
}

body.isMobile.calc #app #g25>.section {
  padding-top: 100px;
}

body.isMobile.calc .toasted-container .infoToast.toasted.bubble.default {
  top: 110px;
  right: unset;
  left: 15px;
}

body.isMobile.app-page .toasted-container {
 z-index: 1;
 bottom: 0;
 left: 0;
 top: unset;
}

body.isMobile.calc .toasted-container:before {
  content: "";
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  height: 150px;
  background: rgba(255,255,255,0.5);
  z-index: -1;
}

body.isMobile.calc .toasted-container.addrawfile.top-right {
  right: 0;
  top: 0;
}

body.isMobile #app #g25.calculator .search-row .sortandshuffle > * {
  vertical-align: middle;
}

body.isMobile #app #editmodal .card {
  padding: 100px 15px 15px 15px;
}

body.isMobile #editModalCard label.token input {
  flex: 1;
}

body.isMobile #editModalCard label.token i.fa.fa-eye,
#editModalCard label.token button.generate-token {
  left: 0;
  top: 0;
}

body.isMobile #drop1.dropzone {
  margin-top: 0;
}

body.isMobile #editModalCard .el-select .el-input .el-input__inner {
  width: 100%;
}

body.isMobile #app #editmodal span.subtext {
  font-size: 1rem;
  width: unset;
  left: 23%;
}

body.isMobile .el-drawer__body {
  width: 100%;
}

body.isMobile.calc .el-drawer.rtl {
  right: 0;
}

body.isMobile .el-drawer__header {
  margin-bottom: 45px;
}

body.isMobile #result.calculator .chartwrapper .profile {
  top: 48%;
}

body #result .chartwrapper .profile.rotateLoading {
pointer-events: none;
}

body.isMobile #app #g25 .ag-xxx-theme-balham.rotated {
  margin-left: 15px;
  margin-right: 15px;
  width: calc(100% - 30px);
  width: -webkit-calc(100% - 30px);
  width: -moz-calc(100% - 30px);
}

body.isMobile #app #g25.calculator #handle1.handle {
  top: 50px;
  z-index: 9;
  width: 45px;
}

body.isMobile #app #admixhelp {
  margin-left: -8px;
}

body.isMobile #app #g25.calculator .collapse-title {
  margin-left: 45px;
}

body.isMobile #app #g25.calculator .run-button a {
  left: unset;
  right: 0;
  width: 70px;
}

body.isMobile.calc #app #g25.calculator .run-button a {
  left: unset;
  right: 50px;
  width: unset;
  padding: 9px 15px 10px 15px;
  margin-top: 18px;
}

body.isMobile #editmodal.fullscreen .v--modal {
  top: 15px!important;
}

body.isMobile .card-collapse .card .card-header a[data-toggle=collapse][aria-expanded=true] i {
  transform: rotate(180deg) translateX(15px);
}

body.isMobile #app #g25 #lower-panel #table {
  margin-top: -50px;
}

body.isMobile #app #g25.calculator .card-collapse .card .card-header a[data-toggle=collapse] {
  display: inline-block;
}

body.isMobile #barchart .label {
  float: none;
  display: block;
  width: 100%;
  text-align: center;
}

body.isMobile #barchart .progress {
  margin-left: 0;
}

body.isMobile #app #g25 #lower-panel #charts #barchart {
  margin-right: 0;
  width: 100%;
  margin-left: 0;
  padding: 0 20px;
}

body.isMobile #result.calculator #lower-panel .chart-wrapper {
  margin-left: 0;
  padding-right: 0;
}

body.isMobile .handle-button {
  top: 65px !important;
}

body.isMobile .btn.btn-primary.plotpca {
  margin-top: -25px;
}

body.isMobile .el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: scroll;
}

body.isMobile #app .card-collapse .card .card-header {
  margin-bottom: 50px;
}

body.isMobile.calc #app .card-collapse .card .card-header {
  margin-bottom: 0;
}

body.isMobile #app #g25 .run-button.pca-button.show a.nav-link.btn.btn-primary {
  left: 0;
  top: 60px;
}

body.isMobile #app .run-button a.transparent {
  margin-top: 9px;
  opacity: 0;
  pointer-events: none;
  width: 60px;
  padding: 9px 15px 10px 15px;
}

body.isMobile #app .run-button:nth-child(2) a.nav-link.btn.btn-primary {
  top: 60px;
  left: unset;
  right: 0;
}

body.isMobile .chartwrapper .profile {
  margin: 0;
  left: 50%;
  top: 50%;
  transform: translate(-47%, -50%);
}

body.isMobile #app #g25 .apexcharts-canvas {
  margin: 0;
}

body.isMobile #app .nav-tabs.nav-tabs-primary {
  margin-bottom: 40px;
}

body.isMobile #app #g25 #lower-panel {
  margin-top: 0;
}

body.isMobile #app .tab-space {
  padding-bottom: 20px;
}

body.isMobile #app #g25.nmonte #mapwrapper .echarts {
  height: 200px;
}

body.isMobile #mapwrapper #map {
  height: 400px !important;
}

body.isMobile #app #maplegend-wrapper {
  bottom: 0;
}

body.isMobile #oraclesmodal .radio {
  margin-top: 65px;
}

body.isMobile #oraclesmodal .v--modal {
  overflow: scroll;
  height: calc(100vh - 30px);
  height: -webkit-calc(100vh - 30px);
  height: -moz-calc(100vh - 30px);
}

body.isMobile #app .v--modal .pagination {
  bottom: 10px !important;
}

body.isMobile #app #g25 #mapwrapper {
  margin-left: 0;
}

body.isMobile #app .ag-xxx-theme-balham .ag-xxx-root {
  overflow-x: scroll;
}

body.isMobile .ag-xxx-layout-auto-height .ag-xxx-center-cols-container {
  min-width: 240px !important;
}

body.isMobile #app .ag-xxx-theme-balham .ag-xxx-ltr .ag-xxx-cell.cell-sheet {
  min-width: 80px !important;
}

body.isMobile #app .ag-xxx-theme-balham {
  width: calc(100% - 30px);
  margin: 0 15px;
  width: -webkit-calc(100% - 30px);
  width: -moz-calc(100% - 30px);
}

body.isMobile .ag-xxx-body-viewport.ag-xxx-row-animation,
body.isMobile #app #g25 .ag-xxx-header {
  width: calc(100% + 700px)!important;
  width: -webkit-calc(100% + 700px)!important;
  width: -moz-calc(100% + 700px)!important;
}

body.isMobile .ag-xxx-theme-balham .ag-xxx-header-cell,
.ag-xxx-theme-balham .ag-xxx-header-group-cell {
  padding-left: 3px;
  padding-right: 3px;
}

body.isMobile #legend-wrapper {
  margin-left: 0;
  top: 0;
}

body.isMobile #barchart #legend {
  left: 0;
  top: 0;
}

body.isMobile #sunburst-wrapper.chartwrapper #maplegend-wrapper {
  bottom: unset;
  top: -100px;
}

body.isMobile #sunburst-wrapper.chartwrapper #sunburst .title-container .title:before,
body.isMobile #sunburst-wrapper.chartwrapper #sunburst .title-container .title:after {
  left: 0 !important;
  width: 100% !important;
}

body.isMobile #sunburst-wrapper.chartwrapper #sunburst .title-container .title {
  min-width: unset !important;
}

body.aisMobile #app #result.calculator.ready > div > div:nth-child(1) {
  display: none;
}

body.isMobile #result.calculator #sunburst-wrapper.chartwrapper .profile {
  margin-left: 0;
  margin-top: 0;
  top: 47%;
  transform: translate(-50%, -50%);
}

body.isMobile #result.calculator #sunburst-wrapper.chartwrapper {
  height: 600px !important;
  position: relative;
}

body.isMobile.nmonte-container #sunburst-wrapper #sunburst {
  top: 100px;
}

body.isMobile #app #g25 #grid .fa-expand-alt {
  display: none;
}

body.isMobile #social.button-container {
  margin-top: 63px;
  text-align: left;
  padding: 13px 10px;
}

body.isMobile #app #social-container #social .btn-lg.btn-save {
  padding: 7.5px 10px;
}

body.isMobile #app #social-container #social .btn-lg.btn-icon.btn-round {
  height: 35px;
  min-width: 35px;
  width: 35px;
}

body.isMobile #app #social-container {
  display: none !important;
}

body.isMobile #pca .mobile.js-plotly-plot .plotly .modebar {
  right: -30px;
}

body.isMobile #app #history-modal .subscriber-overlay .non-sub {
  width: calc(100% - 20px);
  margin-top: 10px;
  width: -webkit-calc(100% - 20px);
  width: -moz-calc(100% - 20px);
}

body.isMobile #app #history-modal .subscriber-overlay {
  align-items: baseline;
}

body.isMobile #history-modal {
  overflow: scroll;
}

body.isMobile .apexcharts-legend {
  overflow: visible;
}

/*pca*/

body.isMobile.pca-container .rightPanel-container.show .rightPanel-items #pcahelp {
  left: 40px;
}

body.isMobile .pcaPanel .el-tabs__content {
  max-width: 100%;
  margin-right: 0;
  padding: 0 15px;
}

body.isMobile.pca-container .pcaPanel.show .rightPanel .handle-button {
  left: 0px;
  top: 0 !important;
  border-left: none;
}

body.isMobile .show.showPanel .rightPanel {
  overflow-y: unset;
  z-index: 999999;
}

body.isMobile.pca-container div.activeTab {
  margin-right: 0;
  padding: 0;
  right: 0;
  overflow-y: hidden;
}

body.isMobile .multiselect--active .multiselect__select {
  top: 5px;
}

body.isMobile .multiselect__select {
  top: 3px;
}

body.isMobile.pca-container .rightPanel .multiselect .fa.download {
  bottom: 5px;
  right: 30px;
}

body.isMobile label.el-checkbox {
  width: unset;
  margin-left: unset;
  margin-bottom: 0;
}

body.isMobile .el-tree-node__expand-icon.expanded {
  transform: rotate(90deg) translate(5px, 5px);
}

body.isMobile #pcaDiv.pca {
  margin-top: 80px;
  height: calc(100vh - 185px);
  width: calc(100vw - 40px);
  height: -webkit-calc(100vh - 185px);
  height: -moz-calc(100vh - 185px);
  width: -webkit-calc(100vw - 40px);
  width: -moz-calc(100vw - 40px);
}

body.isMobile #pca .searchsamples {
  margin: 60px 20px 0;
  width: calc(100% - 40px);
  width: -webkit-calc(100% - 40px);
  width: -moz-calc(100% - 40px);
}



body.isMobile #app .nav-tabs .nav-item {
  margin-right: 10px;
}

body.isMobile .chartwrapper .title {
  top: 65%;
  padding: 5px;
}


body.isMobile .pcaPanel .rightPanel {
  border-left: none;
}

body.isMobile.pca-container .pcaPanel.show.socialready .rightPanel-items #pcahelp {
  top: 5px !important;
}

body.isMobile .el-tabs__header {
  padding: 0 15px;
}

body.isMobile .el-select.select-customgroup {
  width: 100% !important;
}

body.isMobile #app .card-collapse .card .card-header a[data-toggle=collapse] i {
  left: 7px;
}

body.isMobile.nmonte-container #app {
  overflow-y: scroll !important;
}

@media only screen and (max-width: 350px) {
  body.isMobile [class*=navbar-expand-] .navbar-collapse {
    width: 250px;
  }

  body.isMobile .navbar-brand {
    margin-right: 5px;
  }
}
/*** iPhone and iOS Form Input Zoom Fixes ***/
/* Fix Input Zoom on devices older than iPhone 5: */
@media screen and (device-aspect-ratio: 2/3) {
    select, textarea, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"],
    input[type="url"]{ font-size: 16px; }
}

/* Fix Input Zoom on iPhone 5, 5C, 5S, iPod Touch 5g */
@media screen and (device-aspect-ratio: 40/71) {
    select, textarea, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"],
    input[type="url"]{ font-size: 16px; }
}

/* Fix Input Zoom on iPhone 6, iPhone 6s, iPhone 7  */
@media screen and (device-aspect-ratio: 375/667) {
    select, textarea, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"], 
    input[type="tel"], input[type="url"]{ font-size: 16px; }
}

/* Fix Input Zoom on iPhone 6 Plus, iPhone 6s Plus, iPhone 7 Plus, iPhone 8, iPhone X, XS, XS Max  */
@media screen and (device-aspect-ratio: 9/16) {
    select, textarea, input[type="text"], input[type="password"],
    input[type="datetime"], input[type="datetime-local"],
    input[type="date"], input[type="month"], input[type="time"],
    input[type="week"], input[type="number"], input[type="email"],
    input[type="tel"], input[type="url"]{ font-size: 16px; }
}
el-switch__label * {
    font-size: 10px;
    }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
body.isMobile #app #g25.calculator .section.main {
padding-top: 30px;
}
body #app .v--modal-overlay textarea {
background: white;
color: #444;
}
body #app .v--modal-overlay {
color-scheme: light;
}
body.dark #app .el-switch__core {
background: gray;
}
body.isMobile #app .nav-tabs .nav-item {
width: 120px;
display: inline-block;
}
body.isMobile #app .results>div {
text-align: center;
display: inline-block; 
width: 100%;
}
body.app-page.isMobile #app #g25 .nav-tabs>.nav-item>.nav-link {
    height: 34px;
    margin-left: auto;
    font-size: 90%;
    margin-right: auto;
    text-align: center;
    line-height: 0.7em;
}
body.isMobile #app .nav-tabs.nav-tabs-primary, body.nmonte-container.isMobile #app .nav-tabs.nav-tabs-primary {
    margin-bottom: 40px;
    text-align: center; 
    margin-left: auto;
    width: 100%;
    display: inline-block;
    width: 300px; 
}
body.nmonte-container.isMobile #app .nav-tabs.nav-tabs-primary {
display: none;
}
body.nmonte-container.isMobile.app-page #app #g25.nmonte #mapwrapper #maplegend-wrapper {
left: 10px;
bottom: unset;
top: 212px;
}
body.nmonte-container #table .lowerContainer {
margin-top: 100px;
}
body.nmonte-container #app .lowerContainer #grid {
top: 0px;
}
body.nmonte-container #app .lowerContainer #grid.heatmap {
top: 75px;
}
body .pac-container .pac-item {
cursor: pointer;
}
body .pac-container .pac-item:hover {
background: #669dc344;
}
body .el-drawer__wrapper.embedded .el-drawer__body {
    position: relative !important;
    }
body .toasted-container .toasted.BrowserError {
height: 300px;
font-size: 2.5em;
text-align: center;
background: #94351d;
  display: flex;
    justify-content: center;
      align-content: center;
        flex-direction: column;
}
body.isMobile .toasted-container .toasted.BrowserError {
font-size: 1.5em;
line-height: 1.5em;
}
body .toasted-container .toasted.BrowserError .action {
font-size: 15px;
    border: 1px solid white;
    border-radius: 50px;
    padding: 0px 20px;
    margin-top: 20px;
transition: color 0.3s;
color: silver;
}
body .toasted-container .toasted.BrowserError .action:hover {
color: white;
}
body #tosmodal .v--modal-box {
background: #f2f2f2;
}
body.isMobile #barchart .chart-wrapper {
padding: 40px 5% 10px 3%;
}
body.isMobile #result.calculator #chart {
    text-align: center;
    display: flex;
    flex-direction: column;
    position: relative;
    align-content: center;
    flex-wrap: wrap;
    margin-top: -5px;
}
body.isMobile #barchart.mobile {
margin-top: -45px;
margin-bottom: -50px;
    width: 90%;
    margin-left: auto;
		margin-right: auto;
		max-width: 400px;
padding-left: 0;
padding-right: 0;
}
body.isMobile #app .el-drawer__body {
width: 100%;
height: 100%;
position: relative;
z-index: 9;
}
body .aintrojs-helperNumberLayer {
width: 30px;
height: 30px;
line-height: 30px;
font-size: 24px;
left: -36px;
top: -24px;
padding: 5px;
}
body .introjs-helperNumberLayer {
margin-top: -10px;
}
body.app-page .introjs-overlay {
max-width: 100vw !important;
}

body .introjs-tooltipReferenceLayer {
padding-left: 15px;
}
body.isMobilea .introjs-helperNumberLayer {
left: unset;
top: -40px;
right: 25px;
}
body.isMobile .introjs-tooltip {
max-width: 260px;
}

body .vue-dialog.green {
color: white;
background: #10571b;
}
body .vue-dialog.red {
color: white;
background: #900000;
}
body .vue-dialog.brown {
color: white;
background: #906200;
}
body.app-page .introjs-arrow {
display: none !important;
}
body .v--modal {
background: #f2f2f2;
}
  body .v--modal {
    line-height: initial;
  }
body .analyze-button .btn-primary {
color: white;
}
body:not(.dark) #app #page #g25 .multiselect__tags {
border: 1px solid darkgray;
}
body:not(.dark) #app #g25.calculator .section.filters .filtr-search:active {
border: 1px solid darkgray;
}
body:not(.dark) #app #g25.calculator .section.filters .filtr-search {
border: 1px solid silver;
background-color: white;
}
body:not(.dark) .el-switch__core {
border: 1px solid silver;
}
body:not(.dark)  #app #page .allchromo .in-active {
color: gray;
}

</style>
